/**
 * LH-019: Shared Typography Constants
 *
 * CSS variable references for use in inline styles where className-based
 * utilities cannot be applied (e.g. dynamic style objects).
 *
 * Prefer the Tailwind utility classes (font-sans, font-mono, font-display,
 * font-serif) or the semantic type classes (type-headline, type-body,
 * type-label, type-badge) defined in index.css @layer utilities.
 *
 * Use these constants ONLY when an inline style={{ }} is unavoidable.
 */

// ── CSS Variable References (for inline style= props) ──────────────
export const FONT_SANS = "var(--font-sans)";
export const FONT_MONO = "var(--font-mono)";
export const FONT_DISPLAY = "var(--font-display)";
export const FONT_SERIF = "var(--font-serif)";

